import { IAlertItem } from "@cayo/shared/components/Alerts/types";
import { RightPanelType } from "@cayo/shared/components/App/types";
import hightlightedAlerts from "./hightlighted-alerts";

const getAlertType = (alert: IAlertItem) => {
  return alert.categories?.find((c) => c.name === "AlertType" && c.value === "System")
    ? "systemAlerts"
    : alert.categories?.find((c) => c.name === "AlertType" && c.value === "RiskAssessment")
      ? "riskAssessment"
      : "changeAlerts";
};

const hightlightAlerts = (alerts: IAlertItem[]) => {
  alerts.forEach((a) => {
    a.highlighted = hightlightedAlerts.isHighlighted(a);
  });

  return alerts;
};

const getPanelType = (name: string) => {
  let type: RightPanelType | undefined = undefined;
  switch (name) {
    case "systemalerts":
      type = "systemAlerts";
      break;

    case "changealerts":
      type = "changeAlerts";
      break;

    case "riskassessment":
      type = "riskAssessment";
      break;
  }

  return type;
};

const alertUtils = {
  getAlertType,
  hightlightAlerts,
  getPanelType,
};

export default alertUtils;
